module.exports = __webpack_public_path__ + "static/media/ceilings_allImpact_60yd_y.4123681c.csv";